import { cn } from "@-/com.npmjs.cn";
import { Root, Text, type TextProps, type TextRef } from "@rn-primitives/label";
import { Platform } from "@-/com.npmjs.react-native";

export function Label({
  className,
  disabled,
  onPress,
  onPressIn,
  onPressOut,
  ...props
}: Omit<TextProps, "delayLongPress" | "onLongPress"> & React.RefAttributes<TextRef>) {
  return (
    <Root
      className={cn(
        "flex flex-row items-center gap-2 select-none",
        Platform.select({
          web: "cursor-default leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50",
        }),
        disabled && "opacity-50",
      )}
      disabled={disabled}
      onPress={onPress}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
    >
      <Text
        className={cn(
          "text-sm font-medium text-foreground",
          Platform.select({ web: "leading-none" }),
          className,
        )}
        {...props}
      />
    </Root>
  );
}
